import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imageWidth',
  standalone: true
})
export class ImageWidthPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
